import { z } from 'zod';
import { AUTOMATION_STEP_TYPES } from '../constants/automationJobs.js';
export const COMPLIANCE_LANES = ['cold_b2b', 'opt_in_only'];
export const complianceSettingsSchema = z.object({
    compliance_lane: z.enum(COMPLIANCE_LANES).optional(),
    allowed_automation_steps: z.array(z.enum(AUTOMATION_STEP_TYPES)).optional(),
});
export const COMPLIANCE_LANE_LABELS = {
    cold_b2b: 'Cold B2B (legitiem belang + guardrails)',
    opt_in_only: 'Alleen opt-in / consent',
};
//# sourceMappingURL=complianceSettings.js.map